import { useAuthentication } from '@bestseller-bit/frontend-community.utilities.authentication';
import { type FC, type PropsWithChildren, useEffect } from 'react';
import { EnvironmentVariableError } from 'src/domain';
import { identifyUser, initializeTelemetry } from 'src/infrastructure/telemetry';

export const Dash0Provider: FC<PropsWithChildren> = ({ children }) => {
    const { account } = useAuthentication();
    const authToken = import.meta.env.VITE_APP_DASH0_RUM_AUTH_TOKEN;

    if (!authToken) throw new EnvironmentVariableError('Dash0 RUM auth token missing');

    useEffect(() => {
        initializeTelemetry(
            authToken,
            import.meta.env.VITE_APP_DEPLOYMENT_ENVIRONMENT || 'local',
            import.meta.env.VITE_APP_SERVICE_VERSION || 'local',
            import.meta.env.VITE_APP_SERVICE_NAME || 'perci-frontend'
        );
    }, []);

    useEffect(() => {
        if (account) {
            const department = account.idTokenClaims?.department;
            const departmentnumber = account.idTokenClaims?.departmentnumber;
            const jobtitle = account.idTokenClaims?.jobtitle;
            identifyUser(account.localAccountId || account.username, account.name, account.username, {
                department: typeof department === 'string' ? department : undefined,
                departmentnumber:
                    typeof departmentnumber === 'string' || typeof departmentnumber === 'number'
                        ? departmentnumber
                        : undefined,
                jobtitle: typeof jobtitle === 'string' ? jobtitle : undefined,
            });
        }
    }, [account]);

    return <>{children}</>;
};
